import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { TooltipModule } from 'primeng/tooltip';
import { LucideAngularModule, Leaf } from 'lucide-angular';
import { LegendItem } from '../../models';
import { FormatCo2eService } from 'src/app/shared/services/format-co2e.service';

@Component({
  selector: 'app-impact-legend-item',
  standalone: true,
  imports: [CommonModule, TranslocoModule, TooltipModule, LucideAngularModule],
  templateUrl: './impact-legend-item.component.html',
  styles: [],
})
export class ImpactLegendItemComponent {
  @Input() item!: LegendItem;
  @Input() showColorDot: boolean = true;
  @Input() perPerson: boolean = false;
  /**
   * Share of the trip total. Hidden in the reduction dialog, where the rows
   * already carry a before/after pair — a third figure per row made them
   * unreadable — but kept everywhere else the legend is used.
   */
  @Input() showPercentage: boolean = true;
  /** Value before the simulated reduction, when the row is part of a simulation. */
  @Input() previousImpact?: number;

  formatCo2e = inject(FormatCo2eService);

  leafIcon = Leaf;

  /**
   * A simulated row keeps the slot for its former value even when nothing was
   * avoided on it, so ticking a tip never reflows the legend.
   */
  get isSimulated(): boolean {
    return this.previousImpact !== undefined;
  }

  get showsReduction(): boolean {
    return (
      this.previousImpact !== undefined &&
      this.previousImpact > this.item.impact
    );
  }

  get previousValue(): string {
    return this.formatCo2e.formatValue(this.previousImpact ?? 0);
  }

  @Output() itemHover = new EventEmitter<void>();
  @Output() itemLeave = new EventEmitter<void>();

  onMouseEnter(): void {
    this.itemHover.emit();
  }

  onMouseLeave(): void {
    this.itemLeave.emit();
  }
}
